import Cookies from 'js-cookie'

export const VCONSOLE_COOKIE_KEY = 'vconsole_enabled'

function getCookieDomain() {
  if (typeof window === 'undefined') return undefined

  const { hostname } = window.location
  const ipv4Regex = /^(\d{1,3}\.){3}\d{1,3}$/
  const ipv6Regex = /^([0-9a-fA-F]{0,4}:){2,7}[0-9a-fA-F]{0,4}$/

  if (ipv4Regex.test(hostname) || ipv6Regex.test(hostname) || hostname === 'localhost') {
    return undefined
  }

  const parts = hostname.split('.')
  return parts.length >= 2 ? parts.slice(-2).join('.') : undefined
}

function getCookieOptions() {
  const options = { path: '/' }
  const domain = getCookieDomain()
  if (domain) options.domain = domain
  return options
}

/** 读取 vConsole 开关（优先 Cookie，兼容旧版 localStorage） */
export function getVconsoleEnabled() {
  const fromCookie = Cookies.get(VCONSOLE_COOKIE_KEY)
  if (fromCookie === 'Y' || fromCookie === 'N') return fromCookie

  const fromStorage = localStorage.getItem(VCONSOLE_COOKIE_KEY)
  if (fromStorage === 'Y' || fromStorage === 'N') {
    setVconsoleEnabled(fromStorage)
    return fromStorage
  }

  return 'N'
}

export function isVconsoleEnabled() {
  return getVconsoleEnabled() === 'Y'
}

/** 写入 vConsole 开关（Cookie 域级共享，供各子域 H5 读取） */
export function setVconsoleEnabled(value) {
  const enabled = value === 'Y' ? 'Y' : 'N'
  const options = getCookieOptions()
  Cookies.set(VCONSOLE_COOKIE_KEY, enabled, options)
  localStorage.setItem(VCONSOLE_COOKIE_KEY, enabled)
  return enabled
}
